import styled from 'styled-components'
import { Link } from 'react-router-dom'


// CONFIGURATION ---------------------------
export const MenuItem = styled.div`
    height: 100%;
    width: calc((100vw - 28rem) / ${({ length }) => length});
    min-width: 172px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: rgba(${({ rgb }) => `${rgb[0]},${rgb[1]},${rgb[2]}`}, 0.3);
    border-top: 2px solid #FFF;
    border-top: 2px solid rgb(${({ rgb }) => `${rgb[0]},${rgb[1]},${rgb[2]}`});
`;

export const MenuText = styled.div`
    font-family: 'Montserrat';
    font-weight: 550;
    font-size: ${({ fontSize }) => fontSize};
    color: ${({ color }) => color};
    text-align: center;
    text-transform: uppercase;
`;

// GESTIONS DESIGN --------------------------------------------------------
export const Box = styled.div`
    display: flex;
    align-items: center;
    padding: 1.5rem;
    margin-bottom: 1rem;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: var(--shadow-light);
    max-height: 79px;
    overflow: hidden;
`;

export const Text = styled.div`
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 1.8rem;
    color: ${({ color }) => color};
    width: 16%;
    text-align: center;
    text-transform: uppercase;
`;

export const PictureItem = styled.div`
    width: 8rem;
    height: 8rem;
    border-radius: 5px;
    margin: 0 1.5rem;
    background-size: cover;
    background-image: ${({ image }) => image};
    background-position: center;
`;

export const Button = styled(Link)`
    font-family: 'Flamante Round';
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.2rem;
    text-align: center;
    color: var(--color-light-1);
    background-color: ${({ color }) => color};
    border: none;
    border-radius: 5px;
    padding: 1rem 2rem;
    align-self: flex-end;
    outline: none;
`;

export const Icon = styled.svg`
    width: 5.3rem;
    height: 5.3rem;
    cursor: pointer;
    margin: 3rem auto;
    fill: ${({ color }) => color};
`;

export const Icons = styled.svg`
    width: 2.2rem;
    height: 2.2rem;
    cursor: pointer;
    margin: 0 1.75rem;
    fill: ${({ color }) => color};
`;

// ------------------------------------------------------------------

export const Title = styled.h4`
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 1.8rem;
    line-height: 2.2rem;
    color: ${props => props.color};
    text-transform: uppercase;
    margin-bottom: 2.5rem;
`

export const Picture = styled.div`
    height: 80%;
    width: 100%;
    background-size: cover;
    background-image: url(${({ image }) => image}), url('/img/default_image.png');
    background-position: center;
    border-radius: 0 0 2rem 2rem;
`;

export const Heading = styled.h4`
    font-family: 'Flamante Round';
    font-weight: 600;
    font-size: 2.6rem;
    line-height: 2.8rem;
    padding: 0 1rem;
    color: var(--color-light-1);
    text-transform: uppercase;
    background-color: ${({ color }) => color};
    height: 22%;
    border-radius: 2rem 2rem 0 0;
    
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

